import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const SolutionsIndexPage = () => {
  useEffect(() => {
    document.title = 'Çözümler | Kafe, Restoran, Fast Food, Dürümcü, Pastane/Fırın ve Zincirler';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'CafeOtomasyonu çözümleri: Kafe, restoran, fast food, dürümcü, pastane/fırın ve zincir işletmeler için QR Menü, Online Sipariş, POS, Kurye ve Yapay Zeka modülleri.');

    // Canonical
    const canonicalHref = `${siteUrl}/solutions`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    // Structured data: ItemList of solutions
    const structured = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'CafeOtomasyonu Çözümleri',
      hasPart: [
        { '@type': 'WebPage', name: 'Kafeler', url: `${siteUrl}/solutions/cafe` },
        { '@type': 'WebPage', name: 'Restoranlar', url: `${siteUrl}/solutions/restaurant` },
        { '@type': 'WebPage', name: 'Fast Food', url: `${siteUrl}/solutions/fastfood` },
        { '@type': 'WebPage', name: 'Dürümcüler', url: `${siteUrl}/solutions/doner` },
        { '@type': 'WebPage', name: 'Pastane/Fırın', url: `${siteUrl}/solutions/bakery` },
        { '@type': 'WebPage', name: 'Zincir İşletmeler', url: `${siteUrl}/solutions/chain` }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  const sectors = [
    { title: 'Kafeler', desc: 'Temassız QR Menü ve hızlı POS akışı ile masa dönüşünü artırın.', href: '/solutions/cafe' },
    { title: 'Restoranlar', desc: 'Yüksek hacimli siparişlerde mutfak–salon koordinasyonu ve teslimat.', href: '/solutions/restaurant' },
    { title: 'Fast Food', desc: 'Hızlı kasa, kombinasyon menüler ve teslimat performansı.', href: '/solutions/fastfood' },
    { title: 'Dürümcüler', desc: 'Varyasyon/ek malzeme, rota–navigasyon ve performans takibi.', href: '/solutions/doner' },
    { title: 'Pastane/Fırın', desc: 'Talep tahmini, vitrin–stok uyumu ve hızlı satış.', href: '/solutions/bakery' },
    { title: 'Zincir İşletmeler', desc: 'Merkezi menü–fiyat, şube yetkileri ve çoklu şube raporları.', href: '/solutions/chain' }
  ];

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Çözümler</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8 max-w-3xl">Sektörünüze özel modül kombinasyonlarıyla uçtan uca dijital dönüşüm: QR Menü (sürekli ücretsiz), Online Sipariş, POS, Kurye ve Yapay Zeka.</p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {sectors.map((s, i) => (
              <a key={i} href={s.href} className="p-6 rounded-xl border border-gray-200 bg-white hover:shadow transition block">
                <h2 className="font-poppins font-heading-semibold text-xl text-foreground mb-2">{s.title}</h2>
                <p className="text-text-secondary">{s.desc}</p>
                <span className="inline-block mt-3 text-primary font-medium">Detayları Gör →</span>
              </a>
            ))}
          </div>

          <section className="mt-12">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-3">Modüller</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <a href="/qr-menu" className="p-5 rounded-xl border border-gray-200 bg-white hover:shadow transition block">QR Menü – Sürekli Ücretsiz</a>
              <a href="/online-order" className="p-5 rounded-xl border border-gray-200 bg-white hover:shadow transition block">Online Sipariş – Komisyonsuz</a>
              <a href="/pos-system" className="p-5 rounded-xl border border-gray-200 bg-white hover:shadow transition block">POS – Masa/Kasa Yönetimi</a>
              <a href="/courier-system" className="p-5 rounded-xl border border-gray-200 bg-white hover:shadow transition block">Kurye – Canlı Konum</a>
              <a href="/ai-system" className="p-5 rounded-xl border border-gray-200 bg-white hover:shadow transition block">Yapay Zeka – Menü Optimizasyonu</a>
            </div>
          </section>

          <div className="mt-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SolutionsIndexPage;


